import { render, staticRenderFns } from "./PageComponentList.vue?vue&type=template&id=4418104b&"
import script from "./PageComponentList.vue?vue&type=script&lang=ts&"
export * from "./PageComponentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports